<template>
  <div class="r-urgent-modal">
    <Modal footer-hide v-model="show" width="652">
      <div class="password-box">
        <div class="change-password">{{ $t("order.orderUrgent") }}</div>
        <div class="individual-account">
          {{ $t("order.myOrder") }}
        </div>
        <div class="common-flex">
          <div
            class="input-box common-flex common-align-center common-justify-between"
            style="margin-bottom: 17px"
          >
            <div>{{ $t("order.urgentTo") }}</div>
            <DatePicker
              type="datetime"
              :placeholder="$t('customer.selectTip')"
              style="width: 200px"
            ></DatePicker>
          </div>
          <!-- <div class="full">Full</div> -->
          <div class="enable">Enable</div>
        </div>
        <div class="common-flex" style="margin-bottom: 181px">
          <div class="current-balance">{{ $t("order.rushingCost") }}：</div>
          <div class="current-price">$0.00</div>
        </div>
        <div class="common-flex common-flex-end">
          <div class="back common-hover">
            {{ $t("password.back") }}
          </div>
          <div class="submit common-hover">{{ $t("password.submit") }}</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "r-urgent-modal",
  data() {
    return {
      show: false,
    };
  },
  watch: {
    urgentShow: {
      handler(newval, oldval) {
        "newval", newval;
        this.show = newval;
      },
      immediate: true,
    },
    show: {
      handler(newval, oldval) {
        if (newval == false) {
          this.$emit("handlerUrgentShow", newval);
        }
      },
      immediate: true,
    },
  },
  props: {
    urgentShow: Boolean,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
// .r-urgent-modal{
/deep/.ivu-input {
  border: none;
}
.full,
.enable {
  // width: 54px;
  padding: 0 17px;
  border-radius: 2px;
  height: 21px;
  line-height: 21px;
  background: #c9000f;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 21px;
  margin-left: 21px;
}
.enable{
  background: #0C750E;
}

.current-balance {
  font-size: 14px;
  font-family: Roboto, Roboto-Regular;
  font-weight: 400;
  text-align: left;
  color: #999999;
  line-height: 16px;
}
.current-price {
  font-size: 14px;
  font-family: Roboto, Roboto-Regular;
  font-weight: 400;
  text-align: left;
  color: #0a4dcc;
  line-height: 16px;
}
.password-box {
  height: 418px;
  width: 620px;
  padding: 14px 24px;
  .back,
  .submit {
    width: 116px;
    height: 40px;
    background: #b5bac4;
    line-height: 40px;
    font-size: 14px;
    font-family: Roboto, Roboto-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
  .current-balance {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 16px;
  }
  .current-price {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #0a4dcc;
    line-height: 16px;
  }
  .submit {
    background: #0a4dcc;
    margin-left: 14px;
  }
  .change-password {
    font-size: 30px;
    font-weight: 700;
    text-align: left;
    font-family: Times, Times-Bold;
    color: #000000;
    line-height: 37px;
    margin-bottom: 3px;
  }
  .individual-account {
    font-size: 12px;
    font-family: Times, Times-Roman;
    font-weight: Roman;
    text-align: left;
    color: #666666;
    line-height: 14px;
    margin-bottom: 50px;
  }
  .input-box {
    height: 32px;
    width: 372px;
    border-bottom: 1px solid rgba(8, 25, 56, 0.1);
    margin-bottom: 45px;
    padding-bottom: 12px;
    div {
      width: 120px;
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 16px;
    }
    input {
      height: 20px;
      line-height: 20px;
      margin-left: 70px;
      border: none;
      outline: none;
    }
  }
}
// }
</style>


// WEBPACK FOOTER //
// src/components/r-urgent-modal.vue